const myHelper = {
  install(Vue) {
    Vue.filter(
      "formatCurrency",
      function (ammount = 0, currency = 0, showCurrency = true) {
        ammount = ammount.toString();
        if (showCurrency) {
          return ammount.replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " " + currency;
        } else {
          return ammount.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        }
      }
    );

    Vue.mixin({
      methods: {
        osobyFormat: function (max) {
          return this.getTranslation("n_osoby", max);
        },
        pokojeFormat: function (count) {
          return this.getTranslation("n_volne_pokoje", count);
        },
        nociFormat: function (nights) {
          return this.getTranslation("n_noci", nights);
        },
        detiFormat: function (children) {
          return this.getTranslation("n_deti", children);
        },
        dospeliFormat: function (adults) {
          return this.getTranslation("n_dospeli", adults);
        },
        getTranslation: function (name, count = false) {
          if (this.translations.hasOwnProperty(name)) {
            if (count !== false && Array.isArray(this.translations[name])) {
              if (count === 1) {
                return this.translations[name][0];
              }
              if (count > 1 && count < 5) {
                return this.translations[name][1];
              }
              if (count === 0 || count > 0) {
                return this.translations[name][2];
              }
            } else {
              return this.translations[name];
            }
          } else {
            return name;
          }
        },
        getBasicTooltip: function (text) {
          if (text === undefined) return false;
          return {
            content: text,
            html: true,
            classes: 'fshr-basicTooltip',
            offset: 15,
          };
        },
        updateURLParameter: function (url, param, paramVal) {
          var newAdditionalURL = "";
          var tempArray = url.split("?");
          var baseURL = tempArray[0];
          var additionalURL = tempArray[1];
          var temp = "";
          if (additionalURL) {
            tempArray = additionalURL.split("&");
            for (var i = 0; i < tempArray.length; i++) {
              if (tempArray[i].split("=")[0] != param) {
                newAdditionalURL += temp + tempArray[i];
                temp = "&";
              }
            }
          }

          var rows_txt = temp + "" + param + "=" + paramVal;
          return baseURL + "?" + newAdditionalURL + rows_txt;
        },
        generateRoomPriceDescription: function (room, noordering = false) {
          var roomDescArr;
          if (
            (room.hasOwnProperty("room_ordered") &&
              room.room_ordered.length > 0) ||
            noordering
          ) {
            roomDescArr = room.room_price_description;
          } else {
            roomDescArr = room.room_since_price_description;
          }

          var output =
            '<table class="fshr-termOverview-room-prices-description-table"><tbody>';
          if (room.hasOwnProperty("room_label")) {
            output +=
              '<tr><td class="fshr-termOverview-room-prices-description-table-heading" colspan="2">' +
              room.room_label +
              "</td></tr>";
          }
          if (roomDescArr && roomDescArr.length > 0) {
            for (var i in roomDescArr) {
              var roomDesc = roomDescArr[i];

              output += "<tr>";

              output += "<th>" + roomDesc.label + "</th>";
              output +=
                "<td>" +
                this.$options.filters.formatCurrency(
                  roomDesc.value,
                  this.currency
                ) +
                "</td>";

              output += "</tr>";
            }
            output += "</tbody></table>";
            return output;
          } else if (room.room_ordered.length > 0) {
            output += "<tr>";

            var price = 0;
            if (room.hasOwnProperty("room_new_price")) {
              price = room.room_new_price;
            } else {
              price = room.room_old_price;
            }

            if (room.room_price_per_person) {
              output +=
                "<th>" +
                room.room_min_persons +
                " " +
                this.getTranslation("n_osoby", room.room_min_persons) +
                " - " +
                room.room_ordered[0].count +
                " " +
                this.getTranslation("n_pokoj", room.room_ordered[0].count) +
                " </th>";
              output +=
                "<td>" +
                this.$options.filters.formatCurrency(
                  price * room.room_min_persons * room.room_ordered[0].count,
                  this.currency
                ) +
                "</td>";
            } else {
              output +=
                "<th>" +
                room.room_ordered[0].count +
                " " +
                this.getTranslation("n_pokoj", room.room_ordered[0].count) +
                " </th>";
              output +=
                "<td>" +
                this.$options.filters.formatCurrency(
                  price * room.room_ordered[0].count,
                  this.currency
                ) +
                "</td>";
            }

            output += "</tr>";
            output += "</tbody></table>";
            return output;
          }
          return false;
        },
        generateMultipleRoomPriceDescription: function (
          rooms,
          noordering = false
        ) {
          var output = "";
          for (var i in rooms) {
            var room = rooms[i];
            if (
              (room.hasOwnProperty("room_ordered") &&
                room.room_ordered.length) > 0 ||
              noordering
            ) {
              output += this.generateRoomPriceDescription(room, noordering);
            }
          }

          return output === "" ? false : output;
        },
        isIE: function () {
          var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
          return isIE11;
        },
        getFilter: function (filters, name) {
          return filters.filter((val) => val.type === name)[0];
        },
        getFiltersBut: function (filters, name) {
          return filters.filter((val) => val.type !== name);
        },
        deepCopy: function (object){
          return JSON.parse(JSON.stringify(object))
        },
        revitalizeDate: function (filter_settings){
          let cal = this.getFilter(filter_settings.filters, 'calendar');
          if(cal){
            cal.value.range.start = new Date(cal.value.range.start);
            cal.value.range.end = new Date(cal.value.range.end);
          }
          return filter_settings;
        }
      },
    });
  },
};

export default myHelper;
